module.exports = __webpack_public_path__ + "static/img/lg-watersolution.2033b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lg-watersolution.jpg
// module id = ReSF
// module chunks = 0